import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CryptoView } from '../crypto-view';
import { TopicService } from '../topic.service';
import { CryptoService } from '../crypto.service';

@Component({
  selector: 'app-vignere',
  templateUrl: './vignere.component.html',
  styleUrls: ['../topic-style.css', './vignere.component.css']
})
export class VignereComponent extends CryptoView {


  _key: string;
  withLetters: boolean;
  @Input()
  set key(value: string) {
    this._key = value;
    this.current = "0";
  }

  get key(): string {
    return this._key;
  }
  _current: string;
  keyPosition:number;
  plainPosition:number;
  @Input()
  set current(value: string) {
    this._current = value;
    if (this.text && this.key) {
      this.min = Math.max(0, Math.min(+value - 10, this.text.length - 30));
      this.max = this.min + 30;
    }
    if(this.text && this.key && +value < this.text.length){
    this.keyPosition = this.nonEmptyIndex[+value]%this.key.length;
    this.plainPosition = this.text.charAt(+value).charCodeAt(0)-65;
    if(this.direction == "decode"){
      let plain = this.cryptoService.decode('vignere', this.key.charAt(this.keyPosition), this.text.charAt(+value));
      this.plainPosition = plain.charCodeAt(0)-65;
    }
  }
  }

  get current() {
    return this._current;
  }
  private _modus: string
  @Input()
  set modus(value: string) {
    this._modus = value;
  }
  get modus() {
    return this._modus;
  }
  @Input() direction: string;
  private _text: string;
  private nonEmptyIndex: number[];
  @Input()
  set text(value: string) {
    this._text = value;
    if (!value) {
      return;
    }
    let index = 0;
    this.nonEmptyIndex = [];
    for (let c of value) {
      if (c == " ") {
        this.nonEmptyIndex.push(-1);
      } else {
        this.nonEmptyIndex.push(index);
        index++;
      }
    }
    if (value.includes('0') || value.includes('1')) {
      this.withLetters = false;
    } else {
      this.withLetters = true;
    }
    this.current = "0";

  }
  get text() {
    return this._text;
  }
  @Output() studentKey = new EventEmitter<string>();

  inputs: string[];
  hints: string[] = [];
  min: number = 0;
  max: number = 30;

  constructor(topicService: TopicService, protected cryptoService: CryptoService) {
    super(topicService);
    this.inputs = new Array(26).fill(" ");
  }

  /** returns the mapping */
  getMapping() {
    return this.inputs.join("").slice(0, 26);
  }

  /** sets the mapping */
  setmapping(mapping: string) {
    this.inputs = [];
    for (let m of mapping) {
      this.inputs.push(m);
    }
  }

  /** resets the mapping */
  resetmapping() {
    this.setmapping(" ".repeat(this.text ? this.text.length : 1))
  }

  setHints(hints: string[]) {
  }

  /** fills the mapping correctly */
  fillMapping() {
    for (let i of this.createArray(26)) {
      this.inputs[i] = this.key.charAt(i);
    }
  }

  /** normalizes and emits the key */
  onKeyChange() {
    if (this.withLetters) {
      this.key = this.cryptoService.normalizeVignereKeys(this.key, 'letters');
    } else {
      this.key = this.cryptoService.normalizeVignereKeys(this.key, 'digits'); 
    }
    this.studentKey.emit(this.key);
  }


}
